import { Program } from 'screens/Programs/types';

export enum ProgramType {
  IndividualHolisticFramework = 'holisticFramework',
  IndividualCoachHubFramework = 'coachHubFramework',
  Collective = 'coDevelopmentHubs',
  StandaloneAI = 'standaloneAI',
  Executive = 'executive',
}

export type ProgramsByType = {
  [key in ProgramType]: Program[];
};
